import axios from "axios";
import { refreshToken, interceptApiError } from "../middlewares";

const timeout = process.env.VUE_APP_API_TIMEOUT;

const hostInstance = axios.create({
  baseURL: process.env.VUE_APP_API_HOST,
  timeout: timeout * 1000,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json"
  }
});

hostInstance.interceptors.request.use(refreshToken, null, {
  synchronous: true
});

hostInstance.interceptors.response.use(null, interceptApiError, {
  synchronous: true
});

// TODO: add here an interceptor (response type) to handle "401/403"
// errors to push to /logout > /login

export default hostInstance;
